//import { getAnalytics, logEvent } from "@firebase/analytics";
import { initializeApp } from "@firebase/app";
import { getAuth, updatePassword, updateProfile } from "@firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getMessaging, isSupported, onMessage, onRegistered, onUnregistered, register } from "@firebase/messaging";
//import { store } from "../redux/store";
//import * as amplitude from '@amplitude/analytics-browser';
// import posthog from 'posthog-js'

const firebaseConfig = import.meta.env.VITE_APP_FIREBASE_CONFIG;

if (!firebaseConfig) {
  throw new Error(
    "Missing VITE_APP_FIREBASE_CONFIG. Start the client with a tenant script like `npm run start:imex` or `npm run start:rome`."
  );
}

const config = JSON.parse(firebaseConfig);
initializeApp(config);

export const auth = getAuth();
export const firestore = getFirestore();
//export const analytics = getAnalytics();

//export default firebase;
export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      unsubscribe();
      resolve(userAuth);
    }, reject);
  });
};

export const updateCurrentUser = (userDetails) => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      updateProfile(userAuth, userDetails).then(() => {
        unsubscribe();
        resolve(userAuth);
      });
    }, reject);
  });
};

export const updateCurrentPassword = async (password) => {
  const currentUser = await getCurrentUser();

  return updatePassword(currentUser, password);
};
let messagingInstancePromise;

export const getFirebaseMessaging = () => {
  if (!messagingInstancePromise) {
    messagingInstancePromise = isSupported()
      .then((supported) => (supported ? getMessaging() : null))
      .catch((error) => {
        console.warn("Firebase Messaging is unavailable in this browser.", error);
        return null;
      });
  }

  return messagingInstancePromise;
};

const MESSAGING_FID_STORAGE_KEY = "firebase-messaging-fid";

export const getStoredMessagingFid = () => window.sessionStorage.getItem(MESSAGING_FID_STORAGE_KEY);

export const clearStoredMessagingFid = (fid) => {
  if (!fid || getStoredMessagingFid() === fid) {
    window.sessionStorage.removeItem(MESSAGING_FID_STORAGE_KEY);
  }
};

export const observeMessagingRegistration = async ({ onRegistration, onUnregistration } = {}) => {
  const messaging = await getFirebaseMessaging();
  if (!messaging) return null;

  const reportCallbackError = (action, error) => {
    console.warn(`Unable to ${action} the Firebase Messaging installation.`, error);
  };

  const registeredCleanup = onRegistered(messaging, (fid) => {
    window.sessionStorage.setItem(MESSAGING_FID_STORAGE_KEY, fid);
    Promise.resolve(onRegistration?.(fid)).catch((error) => reportCallbackError("synchronize", error));
  });
  const unregisteredCleanup = onUnregistered(messaging, (fid) => {
    clearStoredMessagingFid(fid);
    Promise.resolve(onUnregistration?.(fid)).catch((error) => reportCallbackError("remove", error));
  });

  try {
    await register(messaging, {
      vapidKey: import.meta.env.VITE_APP_FIREBASE_PUBLIC_VAPID_KEY
    });
  } catch (error) {
    registeredCleanup();
    unregisteredCleanup();
    console.log("An error occurred while registering the Firebase installation. ", error);
    return null;
  }

  return () => {
    registeredCleanup();
    unregisteredCleanup();
  };
};

void getFirebaseMessaging()
  .then((messaging) => {
    if (!messaging) return;

    onMessage(messaging, (payload) => {
      console.log("FCM Message received. ", payload);
    });
  })
  .catch((error) => {
    console.warn("Unable to register the Firebase Messaging listener.", error);
  });

// eslint-disable-next-line no-unused-vars
export const logImEXEvent = (eventName, additionalParams, _stateProp = null) => {
  // Disabled as a part of IO-3712.
  // try {
  //   const state = stateProp || store.getState();
  //   const eventParams = {
  //     shop: (state.user && state.user.bodyshop && state.user.bodyshop.shopname) || null,
  //     user: (state.user && state.user.currentUser && state.user.currentUser.email) || null,
  //     partsManagementOnly: state?.user?.partsManagementOnly,
  //     ...additionalParams
  //   };
  //   // axios.post("/ioevent", {
  //   //   useremail: (state.user && state.user.currentUser && state.user.currentUser.email) || null,
  //   //   bodyshopid: (state.user && state.user.bodyshop && state.user.bodyshop.id) || null,
  //   //   operationName: eventName,
  //   //   variables: additionalParams,
  //   //   dbevent: false,
  //   //   env: `master-AIO|${import.meta.env.VITE_APP_GIT_SHA_DATE}`
  //   // });
  //   // console.log(
  //   //   "%c[Analytics]",
  //   //   "background-color: green ;font-weight:bold;",
  //   //   eventName,
  //   //   eventParams
  //   // );
  //   logEvent(analytics, eventName, eventParams);
  //   //amplitude.track(eventName, eventParams);
  //   //posthog.capture(eventName, eventParams);
  // } finally {
  //   //If it fails, just keep going.
  // }
};
